import React, { useEffect, ReactNode } from "react";
import CloseModalButton from "./closeModalButton";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
  maxWidth?: string;
  className?: string;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = "max-w-3xl",
  className = "",
}) => {
  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001]"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      dir="auto"
    >
      <div
        className={`bg-white smHeight:mt-20 mt-0 rounded-xl p-4 md:p-6 w-[95vw] md:w-[90vw] ${maxWidth} mx-4 max-h-[80vh] overflow-y-auto relative ${className} ltr:text-left rtl:text-right`}
        onClick={(e) => e.stopPropagation()}
      >
        <CloseModalButton
          handleClick={onClose}
          className="absolute top-4  ltr:right-4 rtl:left-4"
        />
        {children}
      </div>
    </div>
  );
};

export default Modal;
